/**
 * Asynchronously loads the component for Result page
 */

import React from 'react'
import loadable from 'utils/Loadable'
import { LoadingPage } from 'components/Loading'

export default loadable(() => import(/* webpackChunkName: "ProArtFilterPage" */ './index'), {
  fallback: <LoadingPage />
})
